
var cartData;
var checkout_button = "input[name='checkout'], button[name='checkout'], [href$='checkout'], #PLW_checkout_button";
// var isNotParentMove = true;

function set_payment_option(th) {
  document.getElementById("PLW_purchase-option-info-wrapper").style.display = 'none';
  if (th.id === "PLW_purchase-option-deposit-input") {
    document.getElementById("PLW_purchase-option-info-wrapper").style.display = 'block';
  }
}

function createProductPageDraftOrder(){

  const selectElement = document.getElementById('selected_variant');

// Get the selected option's value
const selectedValue = selectElement.value;
let current_variant_id = selectedValue;

// const current_variant_id = document.querySelector('.product-variant-id').value;
const quantityInput = document.querySelector("input[name='quantity']");


    // Fetch the product data using the URL pattern
    const productHandle = window.location.pathname.split('/').pop(); // Extract product handle from URL
    const productUrl = `${window.Shopify.routes.root}products/${productHandle}.js`;

    fetch(productUrl)
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch product data');
            }
            return response.json();
        })
        .then(product => {
            // Find the current variant using the variant ID
            const variant = product.variants.find(v => v.id == current_variant_id);

            if (!variant) {
                alert('Variant not found for the current product!');
                return;
            }

         

            // Preparing cartData for the draft order
            const cartData = {
               
                note: "",
                attributes: {},
                original_total_price: variant.price * quantityInput.value,
                total_price: variant.price * quantityInput.value,
                total_discount: 0,
                total_weight: product.grams,
                item_count:  quantityInput.value,
                items: [
                    {
                        id: variant.id,
                        properties: {}, // Additional properties if required
                        quantity: quantityInput.value,
                        variant_id: variant.id,
                        key: `${variant.id}:product-page-key`,
                        title: product.title,
                        price: variant.price,
                        original_price: variant.price,
                       // discounted_price: variant.price, // Use discounted price if available
                        line_price: variant.price,
                        original_line_price: variant.price,
                        total_discount: 0,
                        discounts: [],
                        final_price: variant.price,
                        final_line_price: variant.price,
                        product_id: product.id
                    }
                ],
                requires_shipping: true,
               
                items_subtotal_price: variant.price * quantityInput.value,
                cart_level_discount_applications: []
            };


          //calculating discount


            const label = document.getElementById("PLW_purchase-option-label");
            const planDescription = label?.getAttribute("data-plan-description");

             let discountInfo = planDescription.split("|");
          let discount_amount = discountInfo.slice(-1).pop();


        
            discount_amount = "0";
         

           // let discount_info = planDescription;

           // let discount_amount = discount_info.slice(-1).pop();

            let discounted_price = cartData.items[0].discounted_price/100;

            if(discount_amount.includes("%")){
              discount_amount = Number(discount_amount.replace("%", ''));

              var new_discounted_price = (discount_amount/100) * discounted_price;
              
            }else{
              discount_amount = Number(discount_amount);
              
              var new_discounted_price = discount_amount - discounted_price;
            }

            cartData.items[0].discounted_price = new_discounted_price*100;

          var amount_left = (variant.price - new_discounted_price*100)/100;
           cartData.note = `COD Amount : ${amount_left}`;

          
         

                const data = {
                message: "Checkout button clicked",
                cartData: JSON.stringify(cartData),
                action: "create_draft_order_cart",
                purchase_option: "50-percentage",
                isCartDiscount: true
            };

          
      
             fetch('/apps/PLW/deposit', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(data)
              })

                
              .then(response => {
                  if (!response.ok) {
                      throw new Error(`HTTP error! Status: ${response.status}`);
                  }
                  return response.json(); // Parse JSON response if applicable
              })
              .then(responseData => {

                  if(typeof responseData.success.invoice_url !== "undefined"){
                   window.location = responseData.success.invoice_url;
                  }
                  console.log('Request successful:', responseData);
              })
              .catch(error => {
                  console.error('Request failed:', error);
              });
               
        })
     
  

}

document.addEventListener("DOMContentLoaded", function () {



const currentURL = window.location.href;

// Check if the URL contains '/cart'
if (currentURL.includes('/products/')) {


       let shopifybutton = document.querySelector('.shopify-payment-button');

  

    const fullradioButton = document.getElementById('PLW_purchase-option-full');
  const depositradioButton = document.getElementById('PLW_purchase-option-deposit-input');
 
 
 
    fullradioButton.addEventListener('change', () => {
     
      if (fullradioButton.checked) {
      
        deposit_selected = false;
        
      
        const payLaterButton = document.getElementById('paylater_button');
       
   
        
        payLaterButton.style.display = 'none';
        shopifybutton.style.display = 'block';


      }
    });

// depositradioButton.addEventListener('change', () => {
   
//       if (depositradioButton.checked) {
      
//         const payLaterButton = document.getElementById('paylater_button');
      
  
        
//          payLaterButton.style.display = 'block';
//          shopifybutton.style.display = 'none';

        
//          deposit_selected = true;


//       }
//     });

   

  const radioInput = document.getElementById('PLW_purchase-option-deposit-input');
   const PLW_BLOCK = document.querySelector('.m-add-to-cart');


  
    

    
        const buyButton = document.createElement('button');
        buyButton.name = 'add';
        buyButton.textContent = 'Buy it now';
        buyButton.type ="button";
        buyButton.className = 'shopify-payment-button__button shopify-payment-button__button--unbranded';
        buyButton.id = 'paylater_button'; 
      //  buyButton.style.marginTop = '20px'
          buyButton.style.background = 'black';

          

       
        shopifybutton.insertAdjacentElement('afterend',buyButton);
      
     shopifybutton.style.display = 'none';

  const plwBlock = document.getElementById('PLW-block');
const formGroup = document.querySelector('.form-group');

// Insert the PLW-block above the form-group
if (plwBlock && formGroup && formGroup.parentNode) {
  formGroup.parentNode.insertBefore(plwBlock, formGroup);
}

document.querySelectorAll("#paylater_button").forEach(function (element) {
  element.addEventListener("click", function (event) {
    // Prevent the default behavior
    event.preventDefault();

   
    event.stopPropagation();

    console.log("clicked");

        const fullradioButton = document.getElementById('PLW_purchase-option-full');
  const depositradioButton = document.getElementById('PLW_purchase-option-deposit-input');

  if(fullradioButton.checked){
    window.location = "/checkout";
  }else{
     createProductPageDraftOrder();
  }
    
  });
});


}

   

//Code for Current cart page 





});
